<template>
  <div class="plk_styles row">
    <div class="menu_components two columns">
      <Menu/>
    </div>
    <div class="styles ten columns columns-center">
      <codemirror v-model="code" :options="cmOptions" />
    </div>
  </div>
</template>

<script>
import i18n from './i18n'
import Menu from './components/Menu/Index'
import { codemirror } from 'vue-codemirror'
import 'codemirror/lib/codemirror.js'
import 'codemirror/mode/css/css.js'
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/elegant.css'
import { DESIGN } from '@/store'

export default {
  name: 'styles',
  components: {
    Menu,
    codemirror
  },
  data () {
    return {
      cmOptions: {
        tabSize: 2,
        autoCloseTags: true,
        mode: 'text/css',
        theme: 'elegant',
        lineNumbers: true,
        styleActiveLine: true,
        line: true,
        matchBrackets: true
      }
    }
  },
  computed: {
    code: {
      get: function () {
        return this.$store.getters[DESIGN.GETTERS.GET_STYLE]()
      },
      set: function (code) {
        this.$store.commit({
          type: DESIGN.MUTATIONS.SET_STYLE,
          code
        })
      }
    }
  },
  methods: {
    onInitComponent () {
      this.$servicesPLK.translation.init(i18n, { overwrite: false })
    }
  }
}
</script>
<style lang="scss">
.plk_styles .CodeMirror {
  border: 1px solid #dee2e6;
  height: 94vh;
}
</style>
<style scoped lang="scss">
.plk_styles {
  background: #f8f9fa;
}
.styles {
  margin-top: 3vh;
  margin-left: 2%;
  margin-right: 2%;
}
.menu_components {
  padding: 5px;
  background: #848e98;;
  height: 100vh;
  overflow: scroll;
  border-right: solid 1px #dee2e6;
}
@media (max-width: 550px) {
  .plk_styles {
    display: flex;
    flex-flow: column;
  }
}
@media (min-width: 550px) {
  .styles.ten.columns {
    width: 82.6666666667%;
  }
}
</style>
